import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../landing/shared";

const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};

const item = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] } },
};

export const EmployerHero = () => (
    <section
        data-testid="employer-hero-section"
        className="relative flex min-h-svh items-end overflow-hidden bg-night text-ivory lg:min-h-[80vh]"
    >
        <motion.img
            src={IMAGES.employers}
            alt="African executive reviewing workforce plans in a premium office environment"
            className="absolute inset-0 h-full w-full object-cover object-[50%_30%]"
            fetchPriority="high"
            initial={{ scale: 1.06 }}
            animate={{ scale: 1 }}
            transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-night/85 via-night/45 to-night/15" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-night/75 to-transparent" />

        <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-44 sm:pb-20 lg:px-10">
            <motion.div initial="hidden" animate="visible" variants={container} className="max-w-2xl">
                <motion.p variants={item} className="flex items-center gap-3">
                    <span className="h-px w-10 bg-champagne" aria-hidden="true" />
                    <span className="text-xs font-semibold uppercase tracking-[0.32em] text-champagne">
                        Afrinexa Global • International Recruitment
                    </span>
                </motion.p>
                <motion.h1
                    variants={item}
                    className="mt-6 font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
                >
                    Build Your Workforce Beyond Borders
                </motion.h1>
                <motion.p
                    variants={item}
                    className="mt-6 max-w-xl text-base leading-relaxed text-ivory/80 md:text-lg"
                >
                    Connect with qualified international talent through a structured recruitment and
                    manpower process designed around your workforce requirements.
                </motion.p>
                <motion.div variants={item} className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
                    <a
                        href="#employer-form"
                        data-testid="employer-hero-submit-cta"
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-ivory px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:bg-champagne"
                    >
                        Submit Recruitment Request
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                    <a
                        href="/employer/login"
                        data-testid="employer-hero-portal-cta"
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-ivory/40 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors duration-300 hover:border-ivory hover:bg-ivory/10"
                    >
                        Employer Portal
                    </a>
                    <a
                        href="#direct-contact"
                        data-testid="employer-hero-speak-cta"
                        className="inline-flex items-center justify-center whitespace-nowrap px-2 py-4 text-xs font-semibold uppercase tracking-[0.14em] text-ivory/70 transition-colors duration-300 hover:text-champagne"
                    >
                        Speak With Our Team
                    </a>
                </motion.div>
            </motion.div>
        </div>
    </section>
);
